import { ENV, hasSupabase } from "./env";

// Client calls the project's Supabase Edge Functions for anything that needs a
// server-side secret (Resend email). The anon key authenticates the request;
// all provider keys stay server-side inside the function.
async function callFunction(name: string, body: unknown) {
  if (!hasSupabase) {
    return { ok: false, notConfigured: true as const };
  }
  const res = await fetch(`${ENV.supabaseUrl}/functions/v1/${name}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: ENV.supabaseAnonKey,
      Authorization: `Bearer ${ENV.supabaseAnonKey}`,
    },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((json as { error?: string }).error || "Request failed");
  }
  return json as { ok: true; already?: boolean; smsSent?: boolean };
}

export function joinWaitlist(email: string, opts: { source?: string; persona?: string } = {}) {
  return callFunction("website-waitlist", { email, ...opts });
}

export function sendContact(payload: {
  name: string;
  email: string;
  subject?: string;
  message: string;
}) {
  return callFunction("website-contact", payload);
}

/** Primary "Get the app" lead: name + mobile + goal → we text a download link. */
export function requestAppLink(payload: {
  name: string;
  phone: string;
  goal?: string;
  source?: string;
}) {
  return callFunction("website-get-app", payload);
}
